import { Theme } from '@mui/material/styles'
import createStyles from '@mui/styles/createStyles'
import makeStyles from '@mui/styles/makeStyles'
import { palette } from 'c1ui'

export const useStyles = makeStyles((theme: Theme) => {
    return createStyles({
        container: {
            padding: theme.spacing(2),
            border: `1px solid ${palette.border.primary}`,
            borderRadius: '6px',
            background: theme.palette.background.default,
        },
        inputGrid: {
            flexGrow: 1,
        },
    })
})
